import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["triggerRef"];
import React, { useCallback, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import DropdownMenu from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { N700 } from '@atlaskit/theme/colors';
import Toggle from '@atlaskit/toggle';
import Tooltip from '@atlaskit/tooltip';
import { useAIAnswerContext } from '../ai-answer-context';
import { AIOptionsMenuOptionDescription, AIOptionsMenuOptionHeader, AIOptionsMenuOptionText, AIOptionsMenuOptionToggleWrapper, AIOptionsMenuOptionWrapper, AIOptionsMenuWrapper } from './styled';
var messages = defineMessages({
  definition_more_icon_tooltip: {
    id: 'search_ai.definition_more_icon_tooltip',
    defaultMessage: 'See more actions',
    description: 'Tooltip for definition more icon'
  }
});
var renderOptionsMenuControl = function renderOptionsMenuControl(_ref) {
  var onChange = _ref.onChange,
    type = _ref.type,
    isChecked = _ref.isChecked;
  switch (type) {
    case 'toggle':
      return /*#__PURE__*/React.createElement(Toggle, {
        onChange: onChange,
        isChecked: isChecked,
        testId: "ai-answer-options-menu-toggle"
      });
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};
var MoreIconStyled = function MoreIconStyled() {
  return /*#__PURE__*/React.createElement(MoreIcon, {
    label: "reading-aids-menu-button-icon",
    color: "var(--ds-icon-subtle, ".concat(N700, ")")
  });
};
var AIOptionsMenuOption = function AIOptionsMenuOption(_ref2) {
  var header = _ref2.header,
    description = _ref2.description,
    onChange = _ref2.onChange,
    type = _ref2.type,
    isChecked = _ref2.isChecked;
  return /*#__PURE__*/React.createElement(AIOptionsMenuOptionWrapper, null, /*#__PURE__*/React.createElement(AIOptionsMenuOptionText, null, /*#__PURE__*/React.createElement(AIOptionsMenuOptionHeader, null, header), /*#__PURE__*/React.createElement(AIOptionsMenuOptionDescription, null, description)), /*#__PURE__*/React.createElement(AIOptionsMenuOptionToggleWrapper, null, renderOptionsMenuControl({
    onChange: onChange,
    type: type,
    isChecked: isChecked
  })));
};
export var ReadingAidsMenuButton = function ReadingAidsMenuButton() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMenuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var _useAIAnswerContext = useAIAnswerContext(),
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions;
  var _ref3 = readingAidsOptions || {},
    menuOptions = _ref3.menuOptions;
  var toggleMenuOpen = useCallback(function () {
    setMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);
  return /*#__PURE__*/React.createElement(Tooltip, {
    position: "bottom",
    content: formatMessage(messages.definition_more_icon_tooltip)
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    isOpen: isMenuOpen,
    trigger: function trigger(_ref4) {
      var triggerRef = _ref4.triggerRef,
        props = _objectWithoutProperties(_ref4, _excluded);
      return /*#__PURE__*/React.createElement(IconButton, _extends({}, props, {
        appearance: "subtle",
        icon: MoreIconStyled,
        ref: triggerRef,
        onClick: toggleMenuOpen,
        testId: "reading-aids-menu-button",
        label: "reading-aids-menu-button"
      }));
    }
  }, /*#__PURE__*/React.createElement(AIOptionsMenuWrapper, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, (menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.length) && menuOptions.map(function (menuOption, index) {
    return /*#__PURE__*/React.createElement(AIOptionsMenuOption, {
      header: formatMessage(menuOption.label),
      description: menuOption.description && formatMessage(menuOption.description),
      onChange: menuOption.onChange,
      isChecked: menuOption.toggleState,
      type: menuOption.type,
      key: index
    });
  }))));
};